var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-container"},[_c('div',{staticClass:"section-container-wrap"},[_c('Sidebar'),_c('v-content',{staticClass:"ma-0"},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }